<template>
    <v-card stretch>
        <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
            <v-text type="headline">
                Расходы
            </v-text>
        </div>

        <v-data-table empty="Расходов нет" :loader="loading" @sort="$emit('sort', $event)" :sort="sort" :headers="headers" :records="records">
            <template slot="cell-datetime" scope="props">
                <v-text nowrap>
                    {{ moment(props.item.datetime).format('DD.MM.YYYY HH:mm') }}
                </v-text>
            </template>
        </v-data-table>

        <div v-padding="3">
            <v-pagination @click="$emit('paginate', $event)" :total="total" :display="display" :current="page" />
        </div>
    </v-card>
</template>
<script>
    import moment from 'moment';

    export default {
        name: 'costs',
        props: {
            loading: Boolean,
            sort: Object,
            records: Array,
            total: {
                type: Number,
                default: 0,
            },
            page: {
                type: Number,
                default: 1,
            },
            display: {
                type: Number,
                default: 10,
            },
        },
        data() {
            return {
                headers: {
                    datetime: { label: 'Дата / Время' },
                    summa: { label: 'Сумма руб.' },
                    description: { label: 'Основание' },
                }
            }
        },
        methods: {
            moment,
        }
    }
</script>



// WEBPACK FOOTER //
// Costs.vue?42ccc099